import { AxiosResponse } from 'axios';
import client from 'api/client';
import { NotesPayload } from 'api/models/payload/Notes';
import { Note } from 'api/models/response/Notes';

//create new note
export function post(data: NotesPayload): Promise<AxiosResponse<Note>> {
    const url = '/note';
    return client.post<Note>(url, data);
}

//get note
export function get(id: number): Promise<AxiosResponse<Note>> {
    const url = `/note/${id}`;
    return client.get<Note>(url);
}

//edit note
export function put(data: NotesPayload): Promise<AxiosResponse<Note>> {
    const url = `/note/${data.id}`;
    return client.put<Note>(url, data);
}

//delete note
export function deleteNote(id: number): Promise<AxiosResponse<Note>> {
    const url = `/note/${id}`;
    return client.delete<Note>(url);
}

//get all notes
export function getAllNotes(candidate_id: number): Promise<AxiosResponse<{ data: Note[] }>> {
    const url = `/notes/${candidate_id}`;
    return client.get<{ data: Note[] }>(url);
}

//get notes by case
export function getNotesByCase(app_id: number): Promise<AxiosResponse<{ data: Note[] }>> {
    const url = `/application/${app_id}/notes`;
    return client.get<{ data: Note[] }>(url);
}
